export interface Product {
  id: string;
  name: string;
  sku: string;
}

export interface AuditCount {
  productId: string;
  productName: string;
  productSku: string;
  physicalCount: number;
  location: string | null;
  countedAt: string;
}

export interface VarianceItem {
  productId: string;
  productName: string;
  productSku: string;
  systemQty: number;
  physicalQty: number;
  variance: number;
  variancePercent: number;
  status: 'ok' | 'flagged';
  location: string | null;
  // Phase 2 plan 06 (X12)
  serialised?: boolean;
  missingSerials?: string[];
  extraSerials?: string[];
  reason?: string | null;
}

export const COUNT_LOCATION_LABELS: Record<string, string> = {
  FACTORY: 'Factory', WAREHOUSE: 'Warehouse', QUARANTINE: 'Quarantine', IN_TRANSIT: 'In transit', SCRAP_YARD: 'Scrap yard',
};

export const needsReason = (it: VarianceItem) => it.variance !== 0 || (it.missingSerials?.length ?? 0) > 0 || (it.extraSerials?.length ?? 0) > 0;

export interface Audit {
  auditId: string;
  name: string;
  type: string;
  status: 'in_progress' | 'completed' | 'approved';
  createdBy: string;
  createdAt: string;
  completedAt?: string;
  approvedAt?: string;
  locationCode?: string | null;
  counts: AuditCount[];
  results?: {
    items: VarianceItem[];
    summary: { totalCounted: number; matched: number; flagged: number };
  } | null;
}
